import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-erp-solution',
  templateUrl: './erp-solution.component.html',
  styleUrls: ['./erp-solution.component.scss']
})
export class ErpSolutionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
